import {
  required,
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  email,
  ImageInput,
  ImageField,
} from "react-admin";
import { CustomToolbar } from "../../../utils";
import { lower, normalizePhone } from "../../../normalize";

const validateEmail = [email(), required()];
const validateRequired = required();

const RepresentativeEdit = (props) => (
  <Edit title="Editar Representante" {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <TextInput label="Nome" source="name" validate={validateRequired} resettable />

      <TextInput
        placeholder="ex: (11)99507-0544"
        label="Telefone"
        source="phone"
        validate={validateRequired}
        normalize={normalizePhone}
        resettable
      />

      <TextInput
        placeholder="ex: nome@rxpro.com.br"
        label="E-mail"
        source="email"
        type="email"
        normalize={lower}
        validate={validateEmail}
        resettable
      />

      <SelectInput
        label="Função"
        source="roleUser.id"
        choices={[
          { id: 1, name: "Representante" },
          { id: 2, name: "Gerente Distrital" },
        ]}
        validate={validateRequired}
      />

      <div>
        <ImageInput source="avatar" label="Avatar" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </div>
    </SimpleForm>
  </Edit>
);

export default RepresentativeEdit;
